// API adapter.
// - Contact + report submissions use this website project's own backend (live).
// - Live URL scanning uses the stable production LinkExpln scanner API
//   (public, anonymous, CORS-enabled): REACT_APP_SCAN_API_URL.

const SITE_API = process.env.REACT_APP_BACKEND_URL;
export const SCAN_API_BASE = process.env.REACT_APP_SCAN_API_URL || null;

export const isLiveApiConfigured = () => Boolean(SCAN_API_BASE);

async function post(base, path, payload) {
  const res = await fetch(`${base}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail =
      typeof data.detail === "string"
        ? data.detail
        : "Something went wrong. Please try again.";
    const err = new Error(detail);
    err.status = res.status;
    err.retryAfter = res.headers.get("Retry-After");
    throw err;
  }
  return data;
}

export async function scanUrl(url) {
  if (!isLiveApiConfigured()) {
    return { status: "api_pending", url };
  }
  return post(SCAN_API_BASE, "/api/v1/scan/public", { url });
}

export const submitReport = (payload) => post(SITE_API, "/api/report", payload);

export const submitContact = (payload) => post(SITE_API, "/api/contact", payload);
